export default class TeamMembers {
	constructor(container) {
		this.container = container;
        this.teamMembers = this.container.querySelectorAll('[data-team-member]');

		this.handleResize = this.handleResize.bind(this);
		window.addEventListener('resize', this.handleResize);

		this.calculateHeight();
	}

	calculateHeight() {
		this.teamMembers.forEach(member => {
			const memberHeight = member.querySelector('[data-team-member-front]').offsetHeight;
			this.memberBack = member.querySelector('[data-team-member-back]');
			member.style.height = memberHeight + "px";
			this.memberBack.style.height = memberHeight + "px";
		});
	}

	handleResize() {
		this.calculateHeight();
	}

	destroy() {
		window.removeEventListener('resize', this.handleResize);
	}
}